import { useContext, useState } from 'react';
import { AccountContext } from '../AccountContext';

export default function CreatePurchaseTransaction() {
    const { accountId, billingDate, transactionService, setError } = useContext(AccountContext);
    const [amount, setAmount] = useState('');
    const [upfrontPaymentAmount, setUpfrontPaymentAmount] = useState('');
    const [creating, setCreating] = useState(false);
    const [created, setCreated] = useState(false);

    const purchaseAmount = Number(amount);
    const upfrontAmount = upfrontPaymentAmount === '' ? undefined : Number(upfrontPaymentAmount);
    const validAmounts = Number.isFinite(purchaseAmount) && purchaseAmount > 0 &&
        (upfrontAmount === undefined ||
            (Number.isFinite(upfrontAmount) && upfrontAmount >= 0 && upfrontAmount <= purchaseAmount));

    const onCreatePurchaseClicked = async () => {
        if (creating || !validAmounts || !accountId) return;

        setCreating(true);
        setCreated(false);
        try {
            const now = new Date();
            const transactionDate = new Date(billingDate);
            transactionDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
            const effectiveDate = transactionDate.toISOString();
            const description = 'Test Purchase Transaction';
            const spendType = 'Purchase';
            const authorization = await transactionService.authorise(
                accountId, purchaseAmount, effectiveDate, description, spendType
            );

            if (!authorization?.authorizationId) {
                throw new Error('Authorization did not return an ID.');
            }

            await transactionService.createTransaction({
                accountId,
                amount: purchaseAmount,
                upfrontPaymentAmount: upfrontAmount,
                authorisationId: authorization.authorizationId,
                balanceMovementType: 'Purchase',
                description,
                effectiveDate,
                creditRelease: null,
                externalId: null,
                reason: null,
                spendType:  null,
                offerDetails: null
            });
            setCreated(true);
        } catch (error) {
            setError({ source: 'Create Purchase', ...error, message: error?.message });
        } finally {
            setCreating(false);
        }
    };

    return (
        <div className="ui card">
            <div className="custom-card-header">Create Purchase</div>
            <div className="content">
                <div className="ui form">
                    <div className="field">
                        <label htmlFor="purchase-amount">Amount</label>
                        <div className="ui labeled input">
                            <div className="ui label">&pound;</div>
                            <input
                                id="purchase-amount"
                                type="number"
                                min="0.01"
                                step="0.01"
                                placeholder="Amount"
                                value={amount}
                                disabled={creating}
                                onChange={(event) => {
                                    setAmount(event.target.value);
                                    setCreated(false);
                                }}
                            />
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="purchase-upfront-amount">Upfront Payment Amount (optional)</label>
                        <div className="ui labeled input">
                            <div className="ui label">&pound;</div>
                            <input
                                id="purchase-upfront-amount"
                                type="number"
                                min="0"
                                max={purchaseAmount > 0 ? purchaseAmount : undefined}
                                step="0.01"
                                placeholder="Upfront payment amount"
                                value={upfrontPaymentAmount}
                                disabled={creating}
                                onChange={(event) => {
                                    setUpfrontPaymentAmount(event.target.value);
                                    setCreated(false);
                                }}
                            />
                        </div>
                    </div>
                </div>
                {created && <div className="ui positive message" role="status">Purchase created.</div>}
            </div>
            <button
                type="button"
                className={`ui primary button ${creating ? 'loading' : ''}`}
                disabled={creating || !validAmounts || !accountId}
                onClick={onCreatePurchaseClicked}>
                <i className="shopping cart icon" aria-hidden="true" />
                Create Purchase
            </button>
        </div>
    );
}